// Contact info for AS TRAINING - centralized so we update it in one place
export const CONTACT = {
  phone: "786-792-8571",
  phoneIntl: "17867928571", // for wa.me/tel: deep links (no '+' sign per wa.me spec)
  email: "astraining2020@gmail.com",
  instagram: "@astraining2020",
  instagramUrl: "https://instagram.com/astraining2020",
};
